

import React from "react";
import "./SSColumnHeader.scss";
import { BiSearchAlt2 } from "react-icons/bi";

interface Props {
  filters: string[];
  title?: string;
  selectedFilter: string;
  filterSelected: (filter: string) => void;
  searchUpdated: React.Dispatch<React.SetStateAction<string>>;
  searchQuery: string;
  analytics?: any;
  customFilters?: any;
}
interface State {
  isShowingSearch: boolean;
}

interface ItemProps {
  filter: string;
  selectedFilter: string;
  filterSelected: (filter: string) => void;
}

class SSColumnHeaderTab extends React.Component<ItemProps> {
  constructor(props:ItemProps) {
    super(props);
    this.onClick = this.onClick.bind(this);
  }
  onClick() {
    this.props.filterSelected(this.props.filter);
  }
  render() {
    return (
      <div
        className={this.props.selectedFilter === this.props.filter ? "SSColumnHeaderTab selected" : "SSColumnHeaderTab"}
        onClick={this.onClick}
      >
        {this.props.filter}
      </div>
    );
  }
}
export class SSColumnHeader extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { isShowingSearch: false };
    // this.onClick = this.onClick.bind(this)
    this.searchFocused = this.searchFocused.bind(this);
    this.filterSelected = this.filterSelected.bind(this);
    this.searchClicked = this.searchClicked.bind(this);
  }

  // onClick() {
  //   if (this.props.onChange) {
  //     let event = {target:{value:!this.props.checked, checked:!this.props.checked, type:'checkbox', name:this.props.name }}
  //     this.props.onChange(event)
  //   }
  // }
  searchFocused() {
    if (this.props.analytics && this.props.analytics.category) {
      // AnalyticsEvent(this.props.analytics.category, "Search", "Initiated");
    }
  }
  filterSelected(filter:string) {
    if (this.props.analytics && this.props.analytics.category) {
      // AnalyticsEvent(this.props.analytics.category, "Filter Type", filter);
    }
    this.props.filterSelected(filter);
  }
  searchClicked() {
    if (!this.state.isShowingSearch) {
      setTimeout(() => {
        document?.getElementById("headerSearchField")?.focus();
      }, 300);
      this.setState({ isShowingSearch: true });
    } else {
      document.getElementById("headerSearchField")?.blur();
      this.props.searchUpdated("");
      this.setState({ isShowingSearch: false });
    }
  }

  render() {
    const filters = this.props.filters.map((item, index) => {
      return (
        <SSColumnHeaderTab filter={item} selectedFilter={this.props.selectedFilter} filterSelected={this.filterSelected} key={item} />
      );
    });
    const className = this.state.isShowingSearch ? "SSColumnHeader isShowingSearch" : "SSColumnHeader";
    const cancelButton = this.state.isShowingSearch ? (
      <div className="cancelButton" onClick={this.searchClicked}>
        CANCEL
      </div>
    ) : null;
    return (
      <div className={className}>
        <div className="filtersRow">
          {this.props.customFilters ? (
            this.props.customFilters
          ) : (
            <>
              <div className="headerTitle">{this.props.title}</div>
              <div className="filters">{filters}</div>
            </>
          )}
        </div>
        <div className="searchArea">
          <input
            id="headerSearchField"
            onChange={(e) => this.props.searchUpdated(e.target.value)}
            value={this.props.searchQuery}
            placeholder={"Search..."}
            onFocus={this.searchFocused}
          />

          <div className="searchButton" onClick={this.searchClicked}>
            {cancelButton}
            <BiSearchAlt2 />
          </div>
        </div>
      </div>
    );
  }
}
